const state = {
  navstate: '', // 导航内容
  personalcenter: '', // 个人中心默认值
  userName: '', // 登录用户名
  avatar: '' // 用户头像
}
export default state
